var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',[_c('div',{staticClass:"docvue-background"},[_c('img',{attrs:{"src":"/img/landing-page.jpg"}}),_c('div',{staticClass:"display-1 text-center mt-4 pt-4"},[_vm._v("Please check your email for further instructions")])])])}
var staticRenderFns = []

export { render, staticRenderFns }